import Button from 'components/atoms/Button';
import Loader from 'components/molecules/Loader';
import { CustomModalForSave } from 'components/pages/PromoRecommendation';
import LinkPricingSimulator from './LinkPricingSimulator';

interface LinkScenarioModalProps {
    setSaveScenario: Function;
    onSave: Function;
    loading?: boolean;
    saveScenario: any;
    title?: string;
    selectedSimulationKey: any[];
    setSelectedSimulationKeys: Function;
    allScenariosData: any[];
}

function LinkScenarioModal({
    setSaveScenario,
    saveScenario,
    loading,
    onSave,
    title,
    selectedSimulationKey,
    setSelectedSimulationKeys,
    allScenariosData,
}: LinkScenarioModalProps) {
    const handleOk = () => {
        setSaveScenario(false);
    };

    const handleCancel = () => {
        setSaveScenario(false);
    };

    let Footer = () => {
        return (
            <div className="w-full flex justify-end gap-2">
                <Button title={'Cancel'} onClick={() => setSaveScenario(false)} style={{ padding: '0px 20px' }} />
                <Button title={'Save'} onClick={onSave} theme={'Solid'} style={{ padding: '0px 20px' }} />
            </div>
        );
    };

    return (
        <>
            {loading && (
                <div className="fixed inset-0 bg-[#edf0f3] z-[1001] opacity-60">
                    <Loader />
                </div>
            )}
            <CustomModalForSave
                destroyOnClose
                title={title}
                open={saveScenario}
                onOk={handleOk}
                onCancel={handleCancel}
                centered
                width={600}
                footer={Footer()}
            >
                <div className="flex w-full flex-col -mt-4">
                    <LinkPricingSimulator
                        selectedSimulationKey={selectedSimulationKey}
                        setSelectedSimulationKeys={setSelectedSimulationKeys}
                        allScenariosData={allScenariosData}
                        isEditMode={true}
                    />
                </div>
            </CustomModalForSave>
        </>
    );
}
export default LinkScenarioModal;
